import type { OrderData, StartPurchaseData } from '@/types';

type PrefillField = 'email' | 'email2' | 'name' | 'address' | 'address2' | 'zip' | 'city' | 'telephone' | 'country';
type RequireFlag = 'require_email' | 'require_name' | 'require_address' | 'require_city_zip' | 'require_phone' | 'require_country';

// Each field is only used when the shop asks for it (same rule as the old client).
const PREFILL_FIELDS: [PrefillField, RequireFlag][] = [
  ['email', 'require_email'],
  ['email2', 'require_email'],
  ['name', 'require_name'],
  ['address', 'require_address'],
  ['address2', 'require_address'],
  ['zip', 'require_city_zip'],
  ['city', 'require_city_zip'],
  ['telephone', 'require_phone'],
  ['country', 'require_country'],
];

/**
 * Fills the customer information of the order with the sso profile of a logged in user.
 * Only empty fields are filled, so nothing the user has typed is overwritten.
 */
export function prefillFromSso(orderData: OrderData, startPurchaseData: StartPurchaseData): void {
  const customer = startPurchaseData.single_sign_on_login_status?.customer;
  if (!customer) {
    return;
  }

  const source: Partial<Record<PrefillField, string | null | undefined>> = {
    email: customer.email,
    email2: customer.email,
    name: customer.name,
    address: customer.address,
    address2: customer.address2,
    zip: customer.zip,
    city: customer.city,
    telephone: customer.telephone,
    country: customer.country,
  };

  for (const [field, requireFlag] of PREFILL_FIELDS) {
    const value = source[field];
    if (!startPurchaseData[requireFlag] || typeof value !== 'string' || value.trim() === '') {
      continue;
    }
    // The country must be one the shop offers
    if (field === 'country' && !startPurchaseData.countries.includes(value)) {
      continue;
    }
    if (!orderData[field] || orderData[field].trim() === '') {
      orderData[field] = value;
    }
  }
}
